import { render, staticRenderFns } from "./Qyfz.vue?vue&type=template&id=142c4805&"
import script from "./Qyfz.vue?vue&type=script&lang=js&"
export * from "./Qyfz.vue?vue&type=script&lang=js&"
import style0 from "./Qyfz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports